/* globals $ */
function kms_bannerRotate(option={}){
    /**
     * KMS Banner Rotate
     * This will give a static banner an animation
     * @param  {[Object]} option contains banner settings     
     */

    var BANNER_DELAY = Object.hasOwnProperty.call(option, 'delay') ? option['delay'] : 7000;

    $(".banners").each(function(index, el){
        var $banner = $(el);    
        var interval = null;

        function swapBanner(image){
            clearInterval(interval);
            var index = image.index();
            $banner.find('.banner').removeClass('active');
            $banner.find('.banner-nav-item').removeClass('active');
            image.addClass('active');
            $banner.find('.banner-nav-item').eq(index).addClass('active');
            interval = setInterval(moveNext, BANNER_DELAY);
        }
        function selectNextBanner(){
            var $current = $banner.find('.banner.active');
            var $next = $current.next();
            if ($next.length == 0){
                $next = $banner.find('.banner:first');
            }
            return $next;
        }
        function selectPreviousBanner(){
            var $current = $banner.find('.banner.active');
            var $prev = $current.prev();
            if ($prev.length == 0){
                $prev = $banner.find('.banner:last');
            }
            return $prev;
        }
        function moveNext(){
            swapBanner(selectNextBanner());
        }
        function moveBack(){
            swapBanner(selectPreviousBanner());
        }
        function navClick(){
            var $nav = $(this);
            var index = $nav.index();
            var image = $banner.find(".banner").eq(index);
            swapBanner(image);
        }
        interval = setInterval(moveNext, BANNER_DELAY);
        $banner.find('.banner-nav-item').on('click', navClick);
        $banner.find(".move-next").on('click', moveNext);
        $banner.find(".move-prev").on('click', moveBack);
    });
}
window.kms_bannerRotate = kms_bannerRotate;
